/* eslint-disable @typescript-eslint/comma-spacing */
import { Company } from 'API';
import { createContext, Dispatch } from 'react';

/**
 * When a person, company or process request is added, the setNewItem setter in
 * this context will trigger usePaginateList to add the new item to its current
 * list, if it matches the current filter. If it's a contact list, it will be
 * inserted alphabetically (or at the end, if the list has not extended that
 * far into the alphabet yet). If it's a process request list, which is sorted
 * chronologically, it will be inserted at the beginning.
 *
 * When a person,company or PR is updated, the setUpdatedItem setter in this
 * context will trigger usePaginateList to check to see if the updated item
 * is present in its list (in particular, the contacts sidebar).
 * If it is present, the list's item will be updated with the fresh data.
 *
 *
 */

type Context = {
  newItem?: Person | Company;
  setNewItem: Dispatch<Person | Company>;
  updatedItem?: Person | Company;
  setUpdatedItem: Dispatch<Person | Company>;
};

const SidebarContext = createContext<Context>({
  setNewItem: () => { },
  setUpdatedItem: () => {},
});

export default SidebarContext;
